import { switchLoading, getErreurBlock, createFacebookBlockHome, createTwitterBlockHome } from './block';

fetch(`/controller/prodeval/murSocialHome`)
.then(res => res.json())
.then(jsonData => {

    // Traitement des erreurs de base
    if( jsonData.error || jsonData.length === 0 ||
        //(!jsonData.twitter || jsonData.twitter.length === 0) &&
        (!jsonData.facebook || jsonData.facebook.length === 0)
    ) {
        onError();
        return false;
    }

    // Ajout des postes facebook s'ils existent
    if(jsonData.facebook && jsonData.facebook.length > 0) {
        let facebookBlock = createFacebookBlockHome(jsonData.facebook[0])
        $('#socialWall-facebook-1').append(facebookBlock);
    } else {
        removeFacebookBlock(1);
    }

    if(jsonData.facebook && jsonData.facebook.length > 1) {
        let facebookBlock = createFacebookBlockHome(jsonData.facebook[1])
        $('#socialWall-facebook-2').append(facebookBlock);
    } else {
        removeFacebookBlock(2);
    }

    /*
    if(jsonData.twitter && jsonData.twitter[0]) {
        let twitterBlockFirst = createTwitterBlockHome(jsonData.twitter[0]);
        $('#socialWall-twitter').append(twitterBlockFirst)
    }

    if(jsonData.twitter && jsonData.twitter[1]) {
        let twitterBlockSecond = createTwitterBlockHome(jsonData.twitter[1]);
        $('#socialWall-twitter').append(twitterBlockSecond)
    }

    if(!jsonData.twitter || jsonData.twitter.length === 0) {
        removeTwitterBlock();
    }*/

})
.catch(result => {
    onError();
})
.then(result => {
    switchLoading();
})


/**
 * Appeller lors d'une erreur sur la page
 * @return {void}
 */
function onError()
{
    $('.socialWall').append(getErreurBlock($('.socialWall').data('erreur-message')));
    removeFacebookBlock(1);
    removeFacebookBlock(2);
    //removeTwitterBlock();
}

/**
 * @return void
 */
function removeFacebookBlock(id)
{
    $(`#socialWall-facebook-${id}`).remove();
}

/**
 * @return void
 */
/*
function removeTwitterBlock()
{
    $('#socialWall-twitter').remove();
}*/